import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonMenuButton,
  IonPage,
  IonPopover,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { useEffect, useMemo, useState } from "react";
import { useHistory, useParams } from "react-router";
import "./Navbar.css";

import plnSymbol from "../../../assets/img/logo/pln_symbol.svg";
import CheckoutNavbarLink from "./CheckoutNavbarLink";
import {
  chatboxEllipses,
  chevronBackOutline,
  helpCircleOutline,
} from "ionicons/icons";
import PubSub from "../../../lib/PubSub";
import Event from "../../../lib/Event";
import moment from "moment-timezone";
import _ from "underscore";
import StringUtils from "../../../lib/StringUtils";
import StorageUtils from "../../../lib/StorageUtils";
import SegmentUtils from "../../../lib/SegmentUtils";
import PostHogUtils from "../../../lib/PostHogUtils";
import API from "../../../lib/API";

const NavbarV2: React.FC<{
  showSupportOptions?: boolean;
  onSupportChat?: any;
  onSupportCall?: any;
  activeStep?: number;
  showBackButton?: boolean;
  onGoBack?: any;
  store?: any;
  allowNavigation?: boolean;
}> = ({
  showSupportOptions = false,
  onSupportChat = null,
  onSupportCall = null,
  activeStep = 1,
  showBackButton = true,
  onGoBack = null,
  store = null,
  allowNavigation = true,
}) => {
  const [coupon, setCoupon] = useState(false);
  const [couponData, setCouponData] = useState<any>(null);
  const [showCoupon, setShowCoupon] = useState(true);
  const [isOpen, setIsOpen] = useState<any>(false);
  const [openingTime, setOpeningTime] = useState<any>(null);
  const [closingTime, setClosingTime] = useState<any>(null);
  const [openingTimeString, setOpeningTimeString] = useState<any>(null);
  const [closingTimeString, setClosingTimeString] = useState<any>(null);
  const history = useHistory();

  const todayHours = useMemo(() => {
    let today = moment().format("dddd");

    if (!store?.operations?.hours?.standard?.length) {
      return null;
    }

    const todayHours = _.findWhere(store?.operations?.hours?.standard, {
      day: today,
    });

    return todayHours ? todayHours : null;
  }, [store]);

  useEffect(() => {
    PubSub.subscribe(Event.CHECKOUT.COUPON_UPDATED, async (data: any) => {
      const coupon = data?.coupon;

      const forceShow = data?.forceShow;

      if (coupon && couponData?.code == coupon?.code) {
        return;
      }

      let lead = await StorageUtils.get("checkout_lead");

      API.getCouponByCode(coupon?.code, lead?.storeID)
        .then((couponData: any) => {
          setCouponData(coupon);

          if (
            coupon &&
            (sessionStorage.getItem("checkout_show_coupon") !== "false" ||
              forceShow)
          ) {
            setCoupon(true);
            setShowCoupon(true);
          } else {
            setCoupon(false);
          }
        })
        .catch((e: any) => {
          setCouponData(null);
          setCoupon(false);
        });
    });

    StorageUtils.get("checkout_coupon").then(async (data) => {
      if (sessionStorage.getItem("checkout_show_coupon") == "false") {
        return setShowCoupon(false);
      }

      const referral = await StorageUtils.get("checkout_referral");

      if (data) {
        let lead = await StorageUtils.get("checkout_lead");

        console.log("HERE", data?.code, lead?.storeID);

        API.getCouponByCode(data?.code, lead?.storeID)
          .then((couponData: any) => {
            const coupon = couponData?.data?.data?.coupon;

            if (coupon) {
              setCouponData(coupon);
              setCoupon(true);
            }
          })
          .catch((e: any) => {
            setCouponData(null);
            setCoupon(false);
          });
      } else if (referral) {
        setCouponData(referral);
        setCoupon(true);
      }
    });
  }, []);

  useEffect(() => {
    if (
      !todayHours ||
      todayHours?.closed ||
      !todayHours?.opensAt ||
      !todayHours?.closesAt
    ) {
      setIsOpen(false);
      setOpeningTime(null);
      setClosingTime(null);
      setOpeningTimeString(null);
      setClosingTimeString(null);

      return;
    }

    const now = new Date();

    const { opensAt, closesAt } = todayHours;

    const todayDateString = moment().format("YYYY-MM-DD");

    const openingTime = store?.timezone
      ? moment.tz(`${todayDateString}T${opensAt}:00`, store?.timezone)
      : moment(`${todayDateString}T${opensAt}:00`);

    const closingTime = store?.timezone
      ? moment.tz(`${todayDateString}T${closesAt}:00`, store?.timezone)
      : moment(`${todayDateString}T${closesAt}:00`);

    const isOpen = now >= openingTime.toDate() && now <= closingTime.toDate();

    setIsOpen(isOpen);
    setOpeningTime(openingTime);
    setClosingTime(closingTime);
    setOpeningTimeString(openingTime.format("h:mma"));
    setClosingTimeString(closingTime.format("h:mma"));
  }, [todayHours, store]);

  const renderCouponTerms = (
    coupon: any,
    truncated: boolean = true,
    muted: boolean = false,
  ) => {
    if (!coupon) {
      return "";
    }

    if (coupon?.couponUsage == "tiered") {
      let tierStrings: any = [];

      for (let i = 0; i < coupon?.couponTiers?.length; i++) {
        const tier = coupon?.couponTiers[i];

        let intro =
          i == 0
            ? "your first"
            : i == coupon?.couponTiers?.length - 1
            ? `${tier.maxNumberUses == 9999 ? "all " : ""}your following`
            : "your next";
        let value = "";
        let count = `${
          tier.maxNumberUses != 9999 ? tier.maxNumberUses + " " : ""
        }orders`;

        if (tier.maxNumberUses == 1) {
          count = "order";
        }

        if (tier.discountType == "Flat") {
          value = StringUtils.centsToCurrency(tier?.flatDiscount);
        } else {
          value = tier?.percentDiscount * 100 + "%";
        }

        tierStrings.push(
          <>
            {i == coupon?.couponTiers?.length - 1 ? "and " : ""}
            <span
              className={`${
                !muted &&
                "font-weight-bold text-uppercase text-white text-underline"
              }`}
            >
              {value}&nbsp;off
            </span>
            &nbsp;
            {intro}&nbsp;{count}
          </>,
        );
      }

      return (
        <>
          {!truncated && <>You'll receive&nbsp;</>}
          {tierStrings?.map((string, i) => (
            <>
              {string}
              {i != tierStrings?.length - 1 ? ", " : ""}
            </>
          ))}
          .
        </>
      );
    } else {
      return (
        <>
          {!truncated && <>You'll receive</>}
          <span className="font-weight-bold text-uppercase text-white text-underline">
            {" "}
            {coupon?.discountType == "Flat"
              ? StringUtils.centsToCurrency(coupon?.flatDiscount)
              : coupon?.percentDiscount * 100 + "%"}{" "}
            off
          </span>{" "}
          {coupon?.removeFromSubscriptionAfterUses == -1 ? "every order!" : ""}
          {coupon?.removeFromSubscriptionAfterUses == 1
            ? "your first order."
            : ""}
          {coupon?.removeFromSubscriptionAfterUses > 1
            ? `each of your first ${coupon?.removeFromSubscriptionAfterUses} orders.`
            : ""}
        </>
      );
    }
  };

  const getIcon = (iconName = "") => {
    let fill = "var(--dark)";

    let icon: any = null;

    if (iconName == "welcome") {
      icon = (
        <svg
          style={{
            height: 24,

            marginRight: 6,
            position: "relative",
          }}
          fill={fill}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path d="M12,3L20,9V21H15V14H9V21H4V9L12,3Z" />
        </svg>
      );
    }

    if (iconName == "locations") {
      icon = (
        <svg
          style={{
            height: 24,
            marginRight: 6,
            position: "relative",
          }}
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
          <circle cx="12" cy="10" r="3" />
        </svg>
      );
    }

    if (iconName == "plans") {
      icon = (
        <svg
          style={{
            height: 25,
            marginRight: 6,
            position: "relative",
          }}
          fill={fill}
          viewBox="0 0 24 24"
        >
          <path d="M20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20M4,6V18H20V6H4M6,9H18V11H6V9M6,13H16V15H6V13Z" />
        </svg>
      );
    }

    if (iconName == "meals") {
      icon = (
        <svg
          style={{
            height: 22,
            marginRight: 6,
            position: "relative",
            top: 1,
          }}
          fill={fill}
          viewBox="0 0 24 24"
        >
          <title>silverware-fork-knife</title>
          <path d="M11,9H9V2H7V9H5V2H3V9C3,11.12 4.66,12.84 6.75,12.97V22H9.25V12.97C11.34,12.84 13,11.12 13,9V2H11V9M16,6V14H18.5V22H21V2C18.24,2 16,4.24 16,6Z" />
        </svg>
      );
    }

    if (iconName == "checkout") {
      icon = (
        <svg
          style={{
            height: 22,
            marginRight: 6,
            position: "relative",
          }}
          fill={fill}
          viewBox="0 0 24 24"
        >
          <title>cart</title>
          <path d="M17,18C15.89,18 15,18.89 15,20A2,2 0 0,0 17,22A2,2 0 0,0 19,20C19,18.89 18.1,18 17,18M1,2V4H3L6.6,11.59L5.24,14.04C5.09,14.32 5,14.65 5,15A2,2 0 0,0 7,17H19V15H7.42A0.25,0.25 0 0,1 7.17,14.75C7.17,14.7 7.18,14.66 7.2,14.63L8.1,13H15.55C16.3,13 16.96,12.58 17.3,11.97L20.88,5.5C20.95,5.34 21,5.17 21,5A1,1 0 0,0 20,4H5.21L4.27,2M7,18C5.89,18 5,18.89 5,20A2,2 0 0,0 7,22A2,2 0 0,0 9,20C9,18.89 8.1,18 7,18Z" />
        </svg>
      );
    }

    return <>{icon}</>;
  };

  return (
    <IonHeader className="pln-navbar">
      <div>
        {showCoupon && coupon ? (
          <>
            <div
              style={{ position: "relative" }}
              className="coupon-banner pl-3 pl-md-3 pr-4 py-2 text-left font-weight-500"
            >
              <div
                style={{
                  maxWidth: 1200,
                  margin: "auto",
                  position: "relative",
                }}
              >
                <div className="mr-3">
                  {couponData?.referralProgram ? (
                    <>{couponData?.description}</>
                  ) : (
                    <>
                      Discount{" "}
                      <span className="text-underline text-uppercase font-weight-bold">
                        {couponData?.code}
                      </span>
                    </>
                  )}{" "}
                  applied! You'll receive {renderCouponTerms(couponData)}
                </div>
                <div
                  style={{
                    position: "absolute",
                    right: "-0.75rem",
                    top: "50%",
                    transform: "translateY(-50%)",
                    height: 25,
                  }}
                  className="cursor-pointer"
                  onClick={() => {
                    setShowCoupon(false);

                    PubSub.publish(Event.NAVBAR.DISCOUNT_BANNER_CLOSED);

                    sessionStorage.setItem("checkout_show_coupon", "false");
                  }}
                >
                  <svg viewBox="0 0 24 24" style={{ width: 25, height: 25 }}>
                    <path
                      fill="#FFFFFF"
                      d="M13.46,12L19,17.54V19H17.54L12,13.46L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46L13.46,12Z"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </>
        ) : null}

        <div
          className={`px-2 bg-white shadow-sm border-b border-gray-100 py-[0.75rem]`}
        >
          <div
            style={{
              maxWidth: 1200,
              margin: "auto",
              position: "relative",
              display: "flex",
              alignItems: "center",
            }}
          >
            {showBackButton && (
              <>
                <div className="d-block d-md-none" style={{ width: 50 }}>
                  <IonButton
                    fill="clear"
                    className="pln-navbar-button"
                    color="dark"
                    size="small"
                    onClick={() => {
                      if (typeof onGoBack == "function") {
                        onGoBack();
                      }

                      SegmentUtils.track("Button Clicked", {
                        type: "button",
                        color: "dark",
                        fill: "clear",
                        text: "icon:chevronBack",
                        id: "checkout_back_button",
                      });
                    }}
                  >
                    <IonIcon
                      slot="icon-only"
                      icon={chevronBackOutline}
                    ></IonIcon>
                  </IonButton>
                </div>
                <div
                  className="d-none d-md-flex"
                  style={{
                    width: 50,
                    height: 50,
                    // margin: "auto",

                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <IonButton
                    fill="clear"
                    className="pln-navbar-button ml-0"
                    color="dark"
                    size="small"
                    onClick={() => {
                      if (typeof onGoBack == "function") {
                        onGoBack();
                      }
                    }}
                  >
                    <IonIcon
                      slot="icon-only"
                      icon={chevronBackOutline}
                    ></IonIcon>
                  </IonButton>
                </div>
              </>
            )}
            {!showBackButton && (
              <>
                <div className="d-block d-md-none" style={{ width: 50 }}></div>
              </>
            )}

            <div
              className="d-block d-md-none "
              style={{
                flexGrow: 1,
                textAlign: "center",
                position: "relative",
              }}
            >
              {activeStep == 1 || activeStep == 5 ? (
                <img
                  src={plnSymbol}
                  alt="PLN Symbol"
                  width="45px"
                  height="45px"
                  className="mx-auto"
                  style={{
                    height: 45,
                    width: 45,
                    position: "relative",

                    marginTop: 1,
                    marginBottom: 1,
                  }}
                ></img>
              ) : null}
              {activeStep == 1.5 ? (
                <>
                  <h3
                    className="text-uppercase text-dark font-weight-bold"
                    style={{ marginTop: 11, marginBottom: 11 }}
                  >
                    <div className="d-flex align-items-center ion-justify-content-center">
                      <div style={{ lineHeight: 1 }}>
                        {getIcon("locations")}
                      </div>
                      <div style={{ lineHeight: 1.5 }}>
                        {activeStep >= 1.5 ? "Store" : "Start"}
                      </div>
                    </div>
                  </h3>
                </>
              ) : null}
              {activeStep == 2 ? (
                <>
                  <h3
                    className="text-uppercase text-dark font-weight-bold"
                    style={{ marginTop: 11, marginBottom: 11 }}
                  >
                    <div className="d-flex align-items-center ion-justify-content-center">
                      <div style={{ lineHeight: 1 }}>{getIcon("plans")}</div>
                      <div style={{ lineHeight: 1.5 }}>Plans</div>
                    </div>
                  </h3>
                </>
              ) : null}
              {activeStep == 3 ? (
                <>
                  <h3
                    className="text-uppercase text-dark font-weight-bold"
                    style={{ marginTop: 11, marginBottom: 11 }}
                  >
                    <div className="d-flex align-items-center ion-justify-content-center">
                      <div style={{ lineHeight: 1 }}>{getIcon("checkout")}</div>
                      <div style={{ lineHeight: 1.5 }}>Checkout</div>
                    </div>
                  </h3>
                </>
              ) : null}
            </div>

            <img
              className={`d-none ml-[0.75rem] ${
                showBackButton ? "d-md-none" : "d-md-block"
              }`}
              src={plnSymbol}
              alt="PLN Symbol"
              width="50px"
              height="50px"
              style={{ height: 50, width: 50 }}
            ></img>
            <div className="pl-4 d-none d-md-flex pln-checkout-steps">
              {activeStep >= 1.5 ? (
                <CheckoutNavbarLink
                  title={activeStep >= 1.5 ? "Store" : "Start"}
                  active={activeStep == 1.5}
                  disabled={activeStep < 1.5}
                  completed={activeStep > 1.5}
                  iconName="location"
                  onClick={() => {}}
                  clickable={false}
                ></CheckoutNavbarLink>
              ) : (
                <CheckoutNavbarLink
                  title={"Start"}
                  active={activeStep == 1}
                  disabled={activeStep < 1}
                  completed={activeStep > 1}
                  iconName="welcome"
                  onClick={() => {}}
                  clickable={false}
                ></CheckoutNavbarLink>
              )}
              <CheckoutNavbarLink
                iconName="plans"
                title="Plans"
                active={activeStep == 2}
                disabled={activeStep < 2}
                completed={activeStep > 2}
                onClick={() => {}}
                clickable={false}
              ></CheckoutNavbarLink>

              <CheckoutNavbarLink
                title="Checkout"
                iconName="checkout"
                active={activeStep == 3}
                disabled={activeStep < 3}
                completed={activeStep > 3}
                last={true}
                onClick={() => {}}
                clickable={false}
              ></CheckoutNavbarLink>
            </div>

            {!showSupportOptions && (
              <div style={{ textAlign: "right", width: 50 }}></div>
            )}
          </div>
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          left: 0,
          bottom: 0,
          width: "100%",
        }}
        className={`${activeStep == 1 ? "d-none" : "d-flex"} d-md-none`}
      >
        <div
          className={`${
            activeStep >= 1
              ? "bg-orange-500 border-r border-orange-700"
              : "bg-gray-50 border-r border-gray-100"
          }`}
          style={{ width: "25%", height: 4 }}
        ></div>
        <div
          className={`${
            activeStep >= 2
              ? "bg-orange-500 border-r border-orange-700"
              : "bg-gray-50 border-r border-gray-100"
          }`}
          style={{ width: "25%", height: 4 }}
        ></div>
        <div
          className={`${
            activeStep >= 3
              ? "bg-orange-500 border-r border-orange-700"
              : "bg-gray-50 border-r border-gray-100"
          }`}
          style={{ width: "25%", height: 4 }}
        ></div>
        <div
          className={`${activeStep >= 4 ? "bg-orange-500" : "bg-gray-50"}`}
          style={{ width: "25%", height: 4 }}
        ></div>
      </div>
    </IonHeader>
  );
};

export default NavbarV2;
